import { render, staticRenderFns } from "./CustomerTransfer.vue?vue&type=template&id=354ea87b&scoped=true&lang=pug&"
import script from "./CustomerTransfer.vue?vue&type=script&lang=js&"
export * from "./CustomerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransfer.vue?vue&type=style&index=0&id=354ea87b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ea87b",
  null
  
)

/* custom blocks */
import block0 from "./CustomerTransfer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports